export default function pixelsLeftToScroll() {
  // Total document height
  const totalHeight = document.documentElement.scrollHeight;
  // Current scroll position
  const currentScroll = window.scrollY || document.documentElement.scrollTop;
  // Window's inner height
  const windowHeight = window.innerHeight;

  // Calculating pixels left to scroll to reach the bottom
  const pixelsLeft = totalHeight - (currentScroll + windowHeight);

  return pixelsLeft;
}
